// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"767f6fe6","411":"19c91138","488":"e6e77dc9","566":"92708cc6","736":"77f00958","967":"e56f24a7"}[chunkId] + ".chunk.js";
};